module.exports = __webpack_public_path__ + "static/silhouette-guy2-eefa59f35186e31176adb98ef9736d35.svg";